import { Icon } from "react-feather";
import "./PrettyHeader.scss";

export function PrettyHeader({
  icon,
  color = "grey",
  title,
  description,
}: {
  icon?: Icon;
  color?: "red" | "grey"
  title: string;
  description: string;
}) {

  const StartIcon = icon;
  
  return (
    <div data-component="PrettyHeader">
      {StartIcon && <StartIcon className={`color-${color}`} />}
      <span>{title}</span>
      <span className="label middot">&middot;</span>
      <span className="label">{description}</span>
    </div>
  );
}

